module.exports = __webpack_public_path__ + "static/media/Fig-1-9.3bb7720e.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-1-9.png
// module id = 660
// module chunks = 0